
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js"; //var loginobj = actions.LoginGetResult();

export default {
  methods: {
    openAlert: function () {},

    updateHeroOpen() {}

  },
  data: function () {
    return {
      loginobj: actions.LoginGetResult(),
      Options: {}
    };
  },
  on: {
    pageBeforeIn: function (e, page) {},
    pageInit: async function (e, page) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var loginobj = actions.LoginGetResult();
      var settings = await getdata();

      async function getdata() {
        let res = await app.request.promise.get(URLS.GetPlanSettings, {
          UserID: loginobj?.UserID
        });
        var Settings = {};

        if (res && res.data) {
          Settings = JSON.parse(res.data);
          app.preloader.hide();
          self.$setState({
            Options: Settings
          }).then(() => {
            app.smartSelect.get('.plan-size-select').setValue(Settings.SelectedPlanSize);
          });
        }

        return Settings;
      }

      $$("#PriceSaveBtn").on("click", async function () {
        var PlanDisplaySwitch = $$(".toggle-init input").prop("checked");
        var PlanUnassigned = $$("#checkedUnassigned").prop("checked");
        var SelectedPlanSize = app.smartSelect.get('.plan-size-select').getValue();
        var obj = {
          PropertyID: loginobj?.PropertyID,
          UserID: loginobj?.UserID,
          PlanDisplaySwitch: PlanDisplaySwitch,
          PlanUnassigned: PlanUnassigned,
          SelectedPlanSize: SelectedPlanSize
        };
        await app.request.promise.postJSON(URLS.SubmitPlanSettings, {
          obj
        }).then(res => {
          app.preloader.hide();

          if (res.data == null) {
            app.preloader.hide();
            var toastCheckConnection = app.toast.create({
              text: "Error,check internet connection",
              position: "center",
              closeTimeout: 1500
            }).open();
          }

          app.dialog.alert(res.data.message, "Update");
          localStorage.setItem("planDisplaySwitch", JSON.stringify(PlanDisplaySwitch));
          localStorage.setItem("planUnassigned", JSON.stringify(PlanUnassigned));
          var loginobj = actions.LoginGetResult();
          loginobj.SelectedPlanSize = parseInt(SelectedPlanSize);
          localStorage.setItem("loginJson", JSON.stringify(loginobj));
        });
      });
    }
  },
  id: '35d12256f1',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings-donotdisturb><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i></a></div><div class="title sliding">Plan</div><div class=right id=PriceSaveBtn style="margin-right: 10px"><span class=material-icons>save</span></div></div></div><div class=page-content><div class=card style="margin-top: 15px;"><div class="card-content card-content-padding"><div class="list simple-list"><ul><li style="height: 75px;"><div class=field-wrapper><span>Enable</span> <span class=field-subtext>Display plan by rooms</span></div><label class="toggle toggle-init color-blue">';
      r += Template7Helpers.if.call(ctx_1, ctx_1.Options?.PlanDisplaySwitch, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <input id=checkedval type=checkbox checked=checked> ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <input id=checkedval type=checkbox> ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <span class=toggle-icon></span></label></li><li><span>Disable Unassigned</span> <label class="toggle toggle-init color-blue">';
      r += Template7Helpers.if.call(ctx_1, ctx_1.Options?.PlanUnassigned, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <input id=checkedUnassigned type=checkbox checked=checked> ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <input id=checkedUnassigned type=checkbox> ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <span class=toggle-icon></span></label></li><li><div class="item-title item-label" style="width:auto;font-size: 16px;color: black;">Plan Size</div><div class=item-input-wrap><a @smartselect:close=updateHeroOpen() class="item-link smart-select smart-select-init select-value plan-size-select" data-open-in=sheet><select>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Options?.PlanSizes, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div style="display: flex;align-items: center;width: 100%;"><div class=item-title></div><span class=material-icons>expand_more</span></div></div></a></div></li></ul></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .list {
    margin: 10px;
  }

  .icons {
    margin-right: 20px;
  }

  .field-wrapper {
    display: flex;
    flex-direction: column;
  }

  .field-text {
    line-height: 16px;
  }

  .field-subtext {
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.54);
    line-height: 16px;
  }
`,
  styleScoped: false
};
    